import { Resource } from '../../../common/resource.model';
import { UnidadeGestora } from '../../basico/unidade-gestora/unidade-gestora';
import { Entidade } from '../../basico/entidade/entidade';

export class Usuario extends Resource {

  public cpf: string;
  public nome: string;
  public password: string;
  public email: string;
  public profile = 'ROLE_TECNICAN';
  public entidade: Entidade;
  public unidadesGetoras : UnidadeGestora[] = [];
}
